import { render } from "./BlockPageHeader.vue?vue&type=template&id=d0f4dcd8"
import script from "./BlockPageHeader.vue?vue&type=script&lang=js"
export * from "./BlockPageHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__